const totalReducer = (data, key) => {
  return data.reduce((sum, item) => sum + item[key], 0)
}

export { totalReducer }
